import { darken, makeStyles } from '@material-ui/core'

import { lang } from '../../../localization'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    alignItems: 'center',
    gap: 5,
    paddingLeft: 12,
    color: 'grey',
    marginTop: 20,
    borderRadius: 12,
    marginBottom: 4,
    gridTemplateColumns:
      '0.8fr 0.4fr 1fr 1.2fr 1.2fr 1fr 0.6fr 1fr 1fr 1fr 0.2fr',
    backgroundColor:
      theme.palette.type === 'dark'
        ? darken(theme.palette.background.default, 0.3)
        : theme.palette.grey[300],
    [theme.breakpoints.down('lg')]: {
      gridTemplateColumns: '1fr 0.6fr 1fr 1.2fr 1.4fr 1fr 1.3fr 1.3fr 0.1fr'
    }
  },
  text: {
    color: theme.palette.grey[800],
    fontSize: lang === 'en' ? '16px' : '15px',
    textAlign: 'center'
  },
  textFirstElement: {
    color: theme.palette.grey[800],
    fontSize: lang === 'en' ? '16px' : '15px'
  }
}))
export default useStyles
